module.exports = __webpack_public_path__ + "img/verification1.7177809e.png";